import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import ErrorBoundary from './components/ErrorBoundary';
import KibuClub from './pages/KibuClub';
import Directions from './pages/Directions';
import Nav from './components/nav/Nav';

// Scroll to top component
const ScrollToTop: React.FC = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
};

/**
 * Minimal App component specifically for kibu.club
 */
const App: React.FC = () => {
    return (
        <ErrorBoundary showDetails={true}>
            <BrowserRouter
                future={{
                    v7_startTransition: true,
                    v7_relativeSplatPath: true,
                }}>
                <ScrollToTop />
                <div className="build-app bg-background">
                    <Nav />
                    <Routes>
                        {/* Kibu Club landing page - default homepage */}
                        <Route path="/" element={<KibuClub />} />

                        {/* Directions page */}
                        <Route path="/directions" element={<Directions />} />

                    </Routes>
                </div>
            </BrowserRouter>
        </ErrorBoundary>
    );
};

export default App;